import { CurrencyPipe, DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { HorizontalListData, HorizontalListFactory, SimpleHorizontalListAppearanceType, SimpleHorizontalListBgColorType, SimpleHorizontalListTitleSize, SimpleHorizontalListWidgetConfigData } from 'common';
import { LoanData } from '../domain/models/loan.model';

@Injectable()
export class LoanFundedDialogAdapter {
  constructor(
    private readonly currencyPipe: CurrencyPipe,
    private readonly datePipe: DatePipe,
  ) {}

  adaptListData = (loan: LoanData): HorizontalListData[] => {
    return [
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Outstanding balance',
        displayedValue: this.formatCurrency(loan?.loanInfo?.principalBalance),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Payment due',
        displayedValue: this.formatCurrency(loan?.loanInfo?.paymentAmount),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Payment due date',
        displayedValue: this.formatDate(loan?.loanInfo?.paymentDueDate),
      }),
      HorizontalListFactory.createKeyValueStringItem({
        title: 'Loan Amount',
        displayedValue: this.formatCurrency(loan?.offer?.amount),
      }),
    ];
  };

  adaptWidgetConfigData = (): SimpleHorizontalListWidgetConfigData => {
    return {
      backgroundColorType: SimpleHorizontalListBgColorType.Grey,
      cardAppearanceType: SimpleHorizontalListAppearanceType.Outlined,
      titleSize: SimpleHorizontalListTitleSize.Small,
    };
  };

  private formatCurrency(value: number): string {
    return this.currencyPipe.transform(value, '$');
  }

  private formatDate(value: Date): string {
    return this.datePipe.transform(value, 'mediumDate');
  }
}
